import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
import { CSVLink } from 'react-csv';

const ExportOptions = ({ users, siteNames }) => {
  const csvData = users.map(({ id, viewableSites, accountType, ...rest }) => ({
    ...rest,
    accountType: accountType === 'admin' ? 'Portfolio Manager' : 'Site Manager',
    viewableSites: siteNames
      .filter((site) => viewableSites.includes(site.id))
      .map((obj) => obj.name)
      .join(', '),
  }));

  return (
    <div className="flex">
      <IconButton onClick={() => window.print()} aria-label="edit">
        <PrintIcon fontSize="small" />
      </IconButton>

      <CSVLink data={csvData} filename={`Charge-Portal-Users ${new Date()}.csv`} target="_blank">
        <IconButton aria-label="block">
          <DownloadIcon fontSize="small" />
        </IconButton>
      </CSVLink>
    </div>
  );
};

export default ExportOptions;

ExportOptions.propTypes = {
  users: PropTypes.array.isRequired,
  siteNames: PropTypes.array.isRequired,
};
